type Props = { title: string; eyebrow: string; note: string };

export function Stub({ title, eyebrow, note }: Props) {
  return (
    <div className="trc-page">
      <header className="trc-page-header">
        <p className="trc-eyebrow">{eyebrow}</p>
        <h1 className="trc-osw trc-page-title">{title}</h1>
      </header>
      <p className="trc-page-empty">{note}</p>
    </div>
  );
}
